import publicPage from './publicPage';
export default {
    publicPage
};
